import { render, staticRenderFns } from "./SponsorHistoryHeader.vue?vue&type=template&id=ef4c6dc0&"
import script from "./SponsorHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./SponsorHistoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports